import { IconCall, IconFacebook } from "../assets/icons";
import AppLogoWhite from "../assets/images/app-logo-white.png";

const FooterComponent = () => {
  return (
    <footer className="bg-primaryColor w-full px-4 pt-8 pb-24 text-white lg:px-24 sm:px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 gap-4 sm:flex sm:justify-between items-center">
        <div className="sm:flex gap-4 items-center">
          <div className="flex flex-row justify-between mb-4 sm:mb-0">
            <img
              src={AppLogoWhite}
              className="sm:w-12 sm:h-12 lg:w-20 lg:h-20 w-10 h-10 object-contain"
              alt="Logo"
            />
            <div className="flex flex-row items-center gap-4 sm:hidden">
              <a
                href="tel:0935255096"
                data-tooltip={"Gọi điện"}
                className="border p-1 rounded-md border-white"
              >
                <IconCall className="w-6 h-6 text-blue-500 hover:scale-110 transition fill-white" />
              </a>
              <a
                href="https://facebook.com/lylyiphone"
                target="_blank"
                rel="noopener noreferrer"
                data-tooltip={"Liên hệ qua Facebook"}
                className="border p-1 rounded-md border-white"
              >
                <IconFacebook className="w-6 h-6 text-blue-500 hover:scale-110 transition" />
              </a>
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <div className="flex flex gap-1 items-center">
              <span className="text-white font-bold lg:text-xl text-nowrap whitespace-nowrap">
                Chuyên cung cấp các sản phẩm
              </span>
              <span className="text-white font-black lg:text-xl">Apple</span>
            </div>
            <div className="flex flex-col sm:gap-2 text-sm">
              <div className="flex gap-1">
                <span className="text-nowrap whitespace-nowrap sm:text-sm">
                  Địa chỉ:
                </span>
                <span className="font-bold">
                  253 Hùng Vương, Tp. Tam Kỳ, Quảng Nam
                </span>
              </div>
              <span>
                Số điện thoại:{" "}
                <a
                  href="tel:0935255096"
                  className="text-white font-bold"
                  data-tooltip={"Gọi điện"}
                >
                  0935 255 096
                </a>
                {" - "}
                <a
                  href="tel:0901171404"
                  className="text-white font-bold"
                  data-tooltip={"Gọi điện"}
                >
                  0901 171 404
                </a>
              </span>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="flex gap-2 lg:gap-12 items-end justify-between">
          <div className="rounded-2xl overflow-hidden border aspect-[16/9]">
            <iframe
              title="Địa chỉ"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3843.4768338865!2d108.47733807536589!3d15.566151985042815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3169dddb713eca29%3A0xcdc9cda13c108564!2sLy%20iPhone!5e0!3m2!1svi!2s!4v1734669249328!5m2!1svi!2s"
              width="300"
              height="200"
              //   style="border:0;"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="sm:flex hidden sm:flex-col lg:flex-row items-center gap-4 mt-4 sm:order-first">
            <a
              href="tel:0935255096"
              data-tooltip={"Gọi điện"}
              className="border p-1 rounded-md border-white"
            >
              <IconCall className="w-6 h-6 text-blue-500 hover:scale-110 transition fill-white" />
            </a>
            <a
              href="https://facebook.com/lylyiphone"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip={"Liên hệ qua Facebook"}
              className="border p-1 rounded-md border-white"
            >
              <IconFacebook className="w-6 h-6 text-blue-500 hover:scale-110 transition" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterComponent;
